import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const RemoveIcon = createIcon({
  displayName: 'RemoveIcon',
  path: <path d="M19 13H5v-2h14v2z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
